import {
	GROUP_REQUEST_GET,
	GROUP_RESPONSE_GET_SUCCESS,
	GROUP_RESPONSE_GET_FAIL,
	OPEN_CLOSE_ADD_GROUP_MODAL,
	GROUP_REQUEST_POST,
	GROUP_RESPONSE_POST_FAIL,
	ADD_GROUP_RESPONSE_SUCCESS,
	ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR,
	GROUP_RESPONSE_PUT_FAIL,
	DELETE_GROUP_RESPONSE_SUCCESS,
	GROUP_REQUEST_PUT,
	GROUP_REQUEST_UPDATE,
	GROUP_RESPONSE_UPDATE_FAIL,
	GROUP_RESPONSE_UPDATE_SUCCESS,
	BULK_GROUP_REQUEST_POST,
	BULK_GROUP_RESPONSE_POST_FAIL,
	BULK_ADD_GROUP_RESPONSE_SUCCESS,
	BULK_ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR,
	RESET_BULK_ADD_GROUP,
	RESET_GROUP_DELETE,
	GROUP_ADD_TRIGGER,
	GROUP_REQUEST_BY_SITE_GET,
	GROUP_RESPONSE_BY_SITE_GET_SUCCESS,
	GROUP_RESPONSE_BY_SITE_GET_FAIL,
	GROUP_BY_SITE_COPY,
	UPDATE_GROUP_LIST_BY_SITE,
	GROUP_REQUEST_GET_HOME_ADD,
	GROUP_RESPONSE_GET_SUCCESS_HOME_ADD,
	GROUP_RESPONSE_GET_FAIL_HOME_ADD,
	GROUP_REQUEST_CLONE,
	GROUP_RESPONSE_CLONE_SUCCESS,
	GROUP_RESPONSE_CLONE_FAIL,
	RESET_CLONE_GROUP_SUCCESS_MESSAGE,
	TOPOLOGY_REQUEST_GET,
	TOPOLOGY_REQUEST_GET_SUCCESS,
	TOPOLOGY_REQUEST_GET_FAIL,
	RESET_TOPOLOGY_SITES,
	UPDATE_SITES_FOR_PRESELECTION,
	GROUP_COUNTRY_REQUEST_BY_SITE_GET,
	GROUP_COUNTRY_RESPONSE_BY_SITE_GET_SUCCESS,
	GROUP_COUNTRY_RESPONSE_BY_SITE_GET_FAIL,
	LITE_TOPOLOGY_REQUEST_GET,
	LITE_TOPOLOGY_REQUEST_GET_SUCCESS,
	LITE_TOPOLOGY_REQUEST_GET_FAIL,
	SHOW_GROUP_MODAL,
	GROUP_CHILD_REQUEST,
	GROUP_CHILD_RESPONSE_SUCCESS,
	GROUP_CHILD_RESPONSE_FAIL,
	SET_TOPOLOGY_SEARCH_VALUE,
	SET_TOPOLOGY_EXPANDED_VIEW,
} from '../constants/groupConstants';
import { UI_STATES } from '../constants/commonConstants';

/**
 * Reducer function for managing group list state.
 *
 * This reducer handles actions related to fetching group data.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the group list.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const groupListReducer = (
	state = {
		loading: false,
		group: {},
		isAddGroupModalOpen: false,
		groupUpdateRes: {},
		sites: [],
		totalCount: null,
		addGroupSource: null,
	},
	action
) => {
	switch (action.type) {
		case GROUP_REQUEST_GET:
			return {
				...state,
				loading: true,
				status: UI_STATES.LOADING,
			};
		case GROUP_RESPONSE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				status: UI_STATES.SUCCESS,
				group: action.payload,
			};
		case TOPOLOGY_REQUEST_GET:
			return { ...state, loading: true };
		case TOPOLOGY_REQUEST_GET_SUCCESS:
			return {
				...state,
				sites: [...state.sites, ...(action.payload.results || [])],
				loading: false,
				totalCount: action.payload.count,
			};
		case UPDATE_SITES_FOR_PRESELECTION: {
			return {
				...state,
				sites: action.payload,
			};
		}
		case TOPOLOGY_REQUEST_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};

		case GROUP_RESPONSE_GET_FAIL:
			return {
				...state,
				loading: false,
				status: UI_STATES.FAILURE,
				error: action.payload,
			};
		case OPEN_CLOSE_ADD_GROUP_MODAL:
			return {
				...state,
				isAddGroupModalOpen: action.payload,
			};
		case GROUP_REQUEST_POST:
			return {
				...state,
				loading: true,
			};
		case GROUP_RESPONSE_POST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case GROUP_REQUEST_UPDATE:
			return {
				...state,
				loading: true,
			};
		case GROUP_RESPONSE_UPDATE_SUCCESS:
			return {
				...state,
				loading: false,
				groupUpdateRes: action.payload,
			};
		case GROUP_RESPONSE_UPDATE_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case RESET_TOPOLOGY_SITES:
			return {
				...state,
				sites: [],
				totalCount: null,
			};
		case LITE_TOPOLOGY_REQUEST_GET:
			return { ...state, liteLoading: true };
		case LITE_TOPOLOGY_REQUEST_GET_SUCCESS:
			return {
				...state,
				liteLoading: false,
				liteSites: action.payload.results,
				liteTotalCount: action.payload.count,
			};
		case LITE_TOPOLOGY_REQUEST_GET_FAIL:
			return {
				...state,
				liteLoading: false,
				error: action.payload,
			};
		case 'SET_ADD_GROUP_SOURCE':
			return {
				...state,
				addGroupSource: action.payload,
			};
		default:
			return state;
	}
};

export const groupListHomeAddReducer = (
	state = {
		loading: false,
		group: {},
		isAddGroupModalOpen: false,
		groupUpdateRes: {},
	},
	action
) => {
	switch (action.type) {
		case GROUP_REQUEST_GET_HOME_ADD:
			return {
				...state,
				loading: true,
			};
		case GROUP_RESPONSE_GET_SUCCESS_HOME_ADD:
			return {
				...state,
				loading: false,
				group: action.payload,
			};
		case GROUP_RESPONSE_GET_FAIL_HOME_ADD:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case OPEN_CLOSE_ADD_GROUP_MODAL:
			return {
				...state,
				isAddGroupModalOpen: action.payload,
			};
		default:
			return state;
	}
};

export const groupAddReducer = (
	state = { msg: null, error: null, data: [], loading: false },
	action
) => {
	switch (action.type) {
		case GROUP_REQUEST_POST:
			return {
				...state,
				loading: true,
				error: null,
			};
		case GROUP_RESPONSE_POST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case ADD_GROUP_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR:
			return {
				...state,
				msg: null,
				error: null,
			};
		default:
			return state;
	}
};

export const bulkGroupAddReducer = (
	state = { status: null, msg: null, error: null, data: [], loading: false },
	action
) => {
	switch (action.type) {
		case BULK_GROUP_REQUEST_POST:
			return {
				...state,
				loading: true,
				error: null,
				status: UI_STATES.LOADING,
			};
		case BULK_GROUP_RESPONSE_POST_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
				status: UI_STATES.FAILURE,
			};
		case BULK_ADD_GROUP_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
				status: UI_STATES.SUCCESS,
				msg: action.msg,
			};
		case BULK_ADD_GROUP_RESET_SUCCESS_MSG_OR_ERROR:
			return {
				...state,
				...action.payload,
			};
		case RESET_BULK_ADD_GROUP:
			return {
				...state,
				status: null,
				loading: false,
				msg: null,
				error: null,
				data: [],
			};
		default:
			return state;
	}
};

export const groupDeleteReducer = (
	state = {
		successMessageOnDelete: null,
		deleteError: null,
		data: [],
		loading: false,
	},
	action
) => {
	switch (action.type) {
		case GROUP_REQUEST_PUT:
			return {
				...state,
				loading: true,
				deleteError: null,
			};
		case GROUP_RESPONSE_PUT_FAIL:
			return {
				...state,
				loading: false,
				deleteError: action.payload,
			};
		case DELETE_GROUP_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case RESET_GROUP_DELETE:
			return {
				...state,
				loading: false,
				successMessageOnDelete: null,
				deleteError: null,
				data: [],
			};
		// case DELETE_GROUP_RESET_SUCCESS_MSG_OR_ERROR:
		// 	return {
		// 		...state,
		// 		...action.payload,
		// 	};
		default:
			return state;
	}
};
export const groupTriggerReducer = (
	state = { groupAddTrigger: false },
	action
) => {
	switch (action.type) {
		case GROUP_ADD_TRIGGER:
			return {
				...state,
				groupAddTrigger: action.payload,
			};
		case SHOW_GROUP_MODAL:
			return {
				...state,
				...action.payload,
			}
		default:
			return state;
	}
};

export const groupListBySiteReducer = (
	state = {
		groupListBySite: [],
		groupBySiteCopy: [],
		treeData: [],
		loading: false,
		error: null,
	},
	action
) => {
	switch (action.type) {
		case GROUP_REQUEST_BY_SITE_GET:
			return {
				...state,
				loading: true,
			};
		case GROUP_RESPONSE_BY_SITE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				groupListBySite: action.payload,
			};
		case GROUP_RESPONSE_BY_SITE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case GROUP_BY_SITE_COPY:
			return {
				...state,
				groupBySiteCopy: action.payload,
			};
		case UPDATE_GROUP_LIST_BY_SITE:
			return {
				...state,
				groupListBySite: action.payload,
			};
		case GROUP_CHILD_REQUEST:
			return {
				...state,
				loading: true,
				childData: null,
				error: null
			};
		case GROUP_CHILD_RESPONSE_SUCCESS:
			return {
				...state,
				loading: false,
				childData: action.payload,
			};
		case GROUP_CHILD_RESPONSE_FAIL:
			return { ...state, loading: false, error: action.payload };
		default:
			return state;
	}
};

export const cloneGroupReducer = (
	state = {
		loading: false,
		successMessage: null,
		error: null,
		data: null,
	},
	action
) => {
	switch (action.type) {
		case GROUP_REQUEST_CLONE:
			return {
				...state,
				loading: true,
				error: null,
			};
		case GROUP_RESPONSE_CLONE_SUCCESS:
			return {
				...state,
				loading: false,
				successMessage: action.payload.message,
				data: action.payload.data,
			};
		case GROUP_RESPONSE_CLONE_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		case RESET_CLONE_GROUP_SUCCESS_MESSAGE:
			return {
				...state,
				successMessage: null,
				error: null,
			};
		default:
			return state;
	}
};

export const groupCountryListBySiteReducer = (
	state = {
		groupListBySite: [],
		treeData: [],
		loading: false,
		error: null,
	},
	action
) => {
	switch (action.type) {
		case GROUP_COUNTRY_REQUEST_BY_SITE_GET:
			return {
				...state,
				loading: true,
			};
		case GROUP_COUNTRY_RESPONSE_BY_SITE_GET_SUCCESS:
			return {
				...state,
				loading: false,
				groupListBySite: action.payload,
			};
		case GROUP_COUNTRY_RESPONSE_BY_SITE_GET_FAIL:
			return {
				...state,
				loading: false,
				error: action.payload,
			};
		default:
			return state;
	}
};
// export const countryListBySiteReducer = (state = { users: {} }, action) => {
// 	switch (action.type) {
// 		case COUNTRY_REQUEST_BY_SITE_GET:
// 			return {
// 				...state,
// 				loading: true,
// 			};
// 		case COUNTRY_RESPONSE_BY_SITE_GET_SUCCESS:
// 			return {
// 				...state,
// 				loading: false,
// 				userslist: action.payload,
// 			};
// 		case COUNTRY_RESPONSE_BY_SITE_GET_FAIL:
// 			return {
// 				...state,
// 				loading: false,
// 				error: action.payload,
// 			};
// 		default:
// 			return state;
// 	}
// };

export const sidebarSearchReducer = (
	state = {
		topologySearchValue: null,
		isExpandedView: false,
	}, action) => {
	switch (action.type) {
		case SET_TOPOLOGY_SEARCH_VALUE:
			return { ...state, topologySearchValue: action.payload };
		case SET_TOPOLOGY_EXPANDED_VIEW:
			return {
				...state,
				isExpandedView: action.payload,
			};
		default:
			return state;
	}
};

